import { useEffect } from "react";

import type { AppBrandingDto } from "@/api/types";

/** Synchronizes the root route's brand with the browser document, never request headers. */
export function DocumentBranding({ brand }: { brand: AppBrandingDto }): null {
  useEffect(() => {
    const previous = document.documentElement.getAttribute("data-app-branding");
    document.documentElement.setAttribute("data-app-branding", brand);

    return () => {
      if (previous === null) {
        document.documentElement.removeAttribute("data-app-branding");
      } else {
        document.documentElement.setAttribute("data-app-branding", previous);
      }
    };
  }, [brand]);

  return null;
}
